import React, { useState } from "react";

import { Grid, Tab, Tabs, Typography } from "@mui/material";
import mainStyles from "styles";

import ProvisionSCCareForm from "components/sc-care/provision-sc-care-form";
import SCCareRecordsTable from "components/sc-care/sc-care-records-table";
import TabPanel from "components/shared/tab-panel";

const SCCare: React.FC = () => {
  const classes = mainStyles();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (
    _event: React.ChangeEvent<unknown>,
    newValue: number,
  ) => {
    setTabValue(newValue);
  };

  return (
    <Grid container sx={classes.pageRootSpacing} spacing={1}>
      <Grid item xs={12}>
        <Typography variant="h5" gutterBottom data-testid="sc-care-title">
          SC Care
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Manage SC Care insurance customer accounts and policies.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Provision" data-testid="tab-provision" />
          <Tab label="Records" data-testid="tab-records" />
        </Tabs>
        <TabPanel value={tabValue} index={0}>
          <ProvisionSCCareForm />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <SCCareRecordsTable />
        </TabPanel>
      </Grid>
    </Grid>
  );
};

export default SCCare;
